
//PARENT DOMAINS
export const FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST = 'FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST';
export const FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS = 'FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS';
export const FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE = 'FETCH_CLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE';

export const FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST = 'FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_REQUEST';
export const FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS = 'FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_SUCCESS';
export const FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE = 'FETCH_UNCLAIMED_PARENT_DOMAINS_WITH_COUNTS_FAILURE';


//SUBDOMAINS 
export const FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_REQUEST = 'FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_REQUEST';
export const FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_SUCCESS = 'FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_SUCCESS';
export const FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_FAILURE = 'FETCH_CLAIMED_SUBDOMAINS_WITH_COUNTS_FAILURE';
